(function () {
  'use strict';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function eventElement(target) {
    var element = target;
    while (element && element.nodeType !== 1) element = element.parentNode;
    return element || null;
  }

  function closestTarget(target, selector) {
    var element = eventElement(target);
    return element && element.closest ? element.closest(selector) : null;
  }

  function installCartPageControls() {
    var form = document.querySelector('[data-aw-cart-page-form]');
    if (!form || form.getAttribute('data-aw-cart-controls') === 'ready') return;

    form.setAttribute('data-aw-cart-controls', 'ready');
    var page = document.querySelector('[data-aw-cart-page]');
    if (page) page.setAttribute('data-aw-cart-ready', 'native-global');

    var submitting = false;

    function quantityInput(key) {
      var inputs = form.querySelectorAll('[data-aw-cart-quantity-input]');
      var index;
      for (index = 0; index < inputs.length; index += 1) {
        if (inputs[index].getAttribute('data-aw-cart-key') === key) return inputs[index];
      }
      return null;
    }

    function submitUpdate() {
      if (submitting) return;
      submitting = true;

      var marker = form.querySelector('input[data-aw-native-update]');
      if (!marker) {
        marker = document.createElement('input');
        marker.type = 'hidden';
        marker.name = 'update';
        marker.value = 'Update cart';
        marker.setAttribute('data-aw-native-update', '');
        form.appendChild(marker);
      }

      form.setAttribute('aria-busy', 'true');
      HTMLFormElement.prototype.submit.call(form);
    }

    document.addEventListener('click', function (event) {
      var quantityButton = closestTarget(event.target, '[data-aw-cart-quantity]');
      if (quantityButton && form.contains(quantityButton)) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        var input = quantityInput(quantityButton.getAttribute('data-aw-cart-key'));
        if (!input) return;

        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 0;

        var delta = parseInt(quantityButton.getAttribute('data-delta'), 10);
        if (isNaN(delta)) delta = 0;

        input.value = String(Math.max(0, current + delta));
        submitUpdate();
        return;
      }

      var removeButton = closestTarget(event.target, '[data-aw-cart-remove]');
      if (removeButton && form.contains(removeButton)) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        var removeInput = quantityInput(removeButton.getAttribute('data-aw-cart-key'));
        if (!removeInput) return;
        removeInput.value = '0';
        submitUpdate();
      }
    }, true);

    document.addEventListener('change', function (event) {
      var input = closestTarget(event.target, '[data-aw-cart-quantity-input]');
      if (!input || !form.contains(input)) return;

      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var quantity = parseInt(input.value, 10);
      input.value = String(isNaN(quantity) ? 0 : Math.max(0, quantity));
      submitUpdate();
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;

      var submitter = event.submitter || document.activeElement;
      var name = submitter && submitter.getAttribute ? submitter.getAttribute('name') : '';
      if (name === 'checkout') return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      submitUpdate();
    }, true);
  }

  function ready() {
    if (window.Element && !Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = function (selector) {
        var element = this;
        while (element && element.nodeType === 1) {
          if (element.matches(selector)) return element;
          element = element.parentElement;
        }
        return null;
      };
    }

    installCartPageControls();

    var menus = toArray(document.querySelectorAll('[data-awg-mobile-menu]'));

    function syncPageState() {
      var anyOpen = menus.some(function (menu) { return menu.open; });
      document.documentElement.classList.toggle('awg-menu-open', anyOpen);
    }

    menus.forEach(function (menu) {
      var summary = menu.querySelector('summary');

      function syncMenu() {
        if (summary) summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
        syncPageState();
      }

      menu.addEventListener('toggle', syncMenu);

      toArray(menu.querySelectorAll('a')).forEach(function (link) {
        link.addEventListener('click', function () {
          menu.removeAttribute('open');
          syncMenu();
        });
      });

      syncMenu();
    });

    document.addEventListener('click', function (event) {
      menus.forEach(function (menu) {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
      syncPageState();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      menus.forEach(function (menu) { menu.removeAttribute('open'); });
      syncPageState();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) {
        menus.forEach(function (menu) { menu.removeAttribute('open'); });
        syncPageState();
      }
    });

    toArray(document.querySelectorAll('a[href="/#airwinks-size-guide"],a[href="/pages/custom-vent-covers#how-to-measure-custom-size"]')).forEach(function (link) {
      link.setAttribute('href', '/pages/how-to-measure');
    });

    var legacyNavLinks = document.querySelectorAll('.awp-desktop-nav a,.awp-mobile-menu__panel a,.awp-footer__column a,.awc-page__nav a,.awc-page__mobile-panel a,.awc-page__footer-column a,.awc-empty__categories a');
    toArray(legacyNavLinks).forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/search?q=wall+vent') === 0) link.setAttribute('href', '/collections/wall-vent-covers');
      if (href === '/products/6x6-ceiling-vent-cover') link.setAttribute('href', '/collections/ceiling-vent-covers');
    });

    toArray(document.querySelectorAll('.awp-mini-trust span')).forEach(function (item) {
      if (item.textContent.trim().toLowerCase().indexOf('all-metal construction') !== -1) {
        item.innerHTML = '<b aria-hidden="true">✓</b> Installation-specific design';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
